import { render, staticRenderFns } from "./ReviewTest.vue?vue&type=template&id=6daead1a&scoped=true&"
import script from "./ReviewTest.vue?vue&type=script&lang=js&"
export * from "./ReviewTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daead1a",
  null
  
)

export default component.exports